import { clsx } from "clsx";
import {
  Checkbox as ReactAriaCheckbox,
  type CheckboxProps as ReactAriaCheckboxProps,
  type CheckboxRenderProps,
} from "react-aria-components";

import { SymbolIcon } from "../Icon/SymbolIcon.tsx";
import { HStack } from "../Stack/HStack.tsx";
import style from "./CheckBox.module.css";

export interface CheckboxProps extends Omit<ReactAriaCheckboxProps, "children"> {
  children?: React.ReactNode | ((values: CheckboxRenderProps) => React.ReactNode);
}

export const Checkbox = ({ children, ...props }: CheckboxProps) => {
  return (
    <ReactAriaCheckbox {...props}>
      {(renderProps) => (
        <HStack>
          <div
            className={clsx(style.checkbox, {
              [style.selected]: renderProps.isSelected,
              [style.focus]: renderProps.isFocused,
              [style.error]: renderProps.isInvalid,
              [style.disabled]: renderProps.isDisabled,
              [style.readonly]: renderProps.isReadOnly,
            })}
          >
            {renderProps.isSelected && (
              <SymbolIcon
                className={style.check}
                icon={renderProps.isIndeterminate ? "horizontal_rule" : "check"}
                size={16}
              />
            )}
          </div>
          {typeof children === "function" ? children(renderProps) : children}
        </HStack>
      )}
    </ReactAriaCheckbox>
  );
};
